import el from "@cypherpotato/el";
import { Icon } from "./icon";

export function Link(title, href, ...options) {
    return el("a.app-link", title, {
        href
    }, ...options);
}

export function ExternalLink(title, href, ...options) {
    return el("a.app-link",
        title,
        Icon("external-link-line"),
        {
            href,
            target: "_blank",
            ...options
        }
    )
}

export function ButtonLink(...options) {
    return el("a.app-link",
        {
            href: "javascript:void(0)"
        },
        ...options
    )
}